import { Injectable } from '@angular/core'
import { ODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService } from 'common-services'

export interface ITemplateSegment extends IModelBase {
  DisplaySegment: boolean
  ClaimExportConfigId: number
  TemplateSegmentId: number
  Raw837FileId: number
  Raw837FileExportId: number
  ClaimId: number
  ClaimInfo: boolean
  Sequence: number
  Name: string
  SaveSequence: number
  ClaimExportId: number
  TotalElements: number
}

@Injectable()
export class TemplateSegmentODataService extends ODataService<ITemplateSegment> {
  constructor(
    protected http: HttpClient,
    protected config: ODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'TemplateSegments'
  }
}
